export const menuItems = [
  // {
  //     id: 1,
  //     label: "menuitems.menu.text",
  //     isTitle: true
  // },
  // {
  //     id: 2,
  //     label: "menuitems.dashboards.text",
  //     link: "/dashboard/saas",
  //      icon: "bx-home-circle"
  // },
  // {
  //     id: 7,
  //     isLayout: true
  // },
  // {
  //     id: 8,
  //     label: "menuitems.apps.text",
  //     isTitle: true
  // },

  {
    id: 9,
    label: 'menuitems.projects.text',
    icon: 'bx-briefcase-alt-2',
    link: '/proyectos/proyectos',
    nombreModulo: 'proyectos'
  },

  {
    id: 30,
    label: 'menuitems.materiales.text',
    icon: 'bx bx-detail',
    nombreModulo: 'solicitudMaterial',
    subItems: [
      {
        id: 32,
        label: 'menuitems.materiales.list.solicitudes',
        link: '/materiales/solicitudMaterial',
        nombreModulo: 'solicitudMaterial',
        parentId: 30
      }
    ]
  },
  {
    id: 70,
    label: 'menuitems.usuarios.text',
    icon: 'mdi-account-group ',
    nombreModulo: 'usuario',
    subItems: [
      {
        id: 72,
        label: 'menuitems.usuarios.list.usuario',
        link: '/usuarios/usuario',
        nombreModulo: 'usuario',
        parentId: 70
      },
      {
        id: 73,
        label: 'menuitems.usuarios.list.rol',
        link: '/usuarios/rol',
        nombreModulo: 'rol',
        parentId: 70
      },
      {
        id: 74,
        label: 'menuitems.usuarios.list.moduloPermiso',
        link: '/usuarios/moduloPermiso',
        nombreModulo: 'moduloPermiso',
        parentId: 70
      },
      {
        id: 75,
        label: 'menuitems.usuarios.list.cargo',
        link: '/usuarios/cargo',
        nombreModulo: 'cargo',
        parentId: 70
      },
      {
        id: 76,
        label: 'menuitems.usuarios.list.usuarioBodegaMovil',
        link: '/usuarios/usuarioBodega',
        nombreModulo: 'usuarioBodega',
        parentId: 70
      }
    ]
  },

  {
    id: 90,
    label: 'menuitems.mantenedores.text',
    icon: 'bx bx-slider-alt',
    nombreModulo: 'mantenedores',
    subItems: [
      {
        id: 91,
        label: 'menuitems.mantenedores.list.actividad',
        link: '/mantenedores/actividad',
        nombreModulo: 'actividad',
        parentId: 90
      },
      {
        id: 92,
        label: 'menuitems.mantenedores.list.actividadTipoProyectoConfiguracion',
        link: '/mantenedores/actividadTipoProyectoConfiguracion',
        nombreModulo: 'actividadTipoProyectoConfiguracion',
        parentId: 90
      },
      {
        id: 93,
        label: 'menuitems.mantenedores.list.tipoDocumento',
        link: '/mantenedores/tipoDocumento',
        nombreModulo: 'tipoDocumento',
        parentId: 90
      },
      {
        id: 94,
        label: 'menuitems.mantenedores.list.nombreDocumento',
        link: '/mantenedores/nombreDocumento',
        nombreModulo: 'nombreDocumento',
        parentId: 90
      },
      {
        id: 95,
        label: 'menuitems.mantenedores.list.tipoProyecto',
        link: '/mantenedores/tipoProyecto',
        nombreModulo: 'tipoProyecto',
        parentId: 90
      },
      {
        id: 96,
        label: 'menuitems.mantenedores.list.tipoCliente',
        link: '/mantenedores/tipoCliente',
        nombreModulo: 'tipoCliente',
        parentId: 90
      },
      {
        id: 97,
        label: 'menuitems.mantenedores.list.tipoVenta',
        link: '/mantenedores/tipoVenta',
        nombreModulo: 'tipoVenta',
        parentId: 90
      },
      {
        id: 98,
        label: 'menuitems.mantenedores.list.tipoInstalacion',
        link: '/mantenedores/tipoInstalacion',
        nombreModulo: 'tipoInstalacion',
        parentId: 90
      },
      {
        id: 99,
        label: 'menuitems.mantenedores.list.etapaProyecto',
        link: '/mantenedores/etapaProyecto',
        nombreModulo: 'etapaProyecto',
        parentId: 90
      },
      {
        id: 101,
        label: 'menuitems.mantenedores.list.subEtapaProyecto',
        link: '/mantenedores/subEtapaProyecto',
        nombreModulo: 'subEtapaProyecto',
        parentId: 90
      },
      {
        id: 101,
        label: 'menuitems.mantenedores.list.normativa',
        link: '/mantenedores/normativa',
        nombreModulo: 'normativa',
        parentId: 90
      },
      {
        id: 102,
        label: 'menuitems.mantenedores.list.appFlexEnergetica',
        link: '/mantenedores/appFlexEnergetica',
        nombreModulo: 'appFlexEnergetica',
        parentId: 90
      },
      {
        id: 103,
        label: 'menuitems.mantenedores.list.templateGantt',
        link: '/mantenedores/templateGantt',
        nombreModulo: 'templateGantt',
        parentId: 90
      }
    ]
  },
  {
    id: 110,
    label: 'menuitems.bodegamovil.text',
    icon: 'bx bx-detail',
    nombreModulo: 'solicitudMaterial',
    subItems: [
      {
        id: 111,
        label: 'menuitems.bodegamovil.list.solicitudmaterialbodega',
        link: '/bodegamovil/solicitudMaterialBodega',
        nombreModulo: 'solicitudMaterialBodega',
        parentId: 110
      },
      {
        id: 112,
        label: 'menuitems.bodegamovil.list.solicitudes',
        link: '/bodegamovil/solicitudes',
        nombreModulo: 'solicituidesBodegaMovil',
        parentId: 110
      },
      {
        id: 113,
        label: 'menuitems.bodegamovil.list.inventarioBodega',
        link: '/bodegamovil/inventario',
        nombreModulo: 'inventarioBodega',
        parentId: 110
      }
    ]
  },
  {
    id: 115,
    label: 'menuitems.supplying.text',
    icon: 'bx bx-detail',
    nombreModulo: 'abastecimiento',
    subItems: [
      {
        id: 116,
        label: 'menuitems.supplying.list',
        link: '/supplying',
        nombreModulo: 'abastecimiento'
      },
      {
        id: 117,
        label: 'menuitems.supplying-summary.text',
        link: '/supplying-summary',
        nombreModulo: 'abastecimiento'
      }
    ]
  },
  {
    id: 118,
    label: 'menuitems.smartsheet.index',
    icon: 'mdi-marker-check',
    nombreModulo: 'nested_webpage_c_i',
    subItems: [
      {
        id: 119,
        label: 'menuitems.smartsheet.general',
        link: '/smartsheet/general',
        nombreModulo: 'nested_webpage_c_i'
      },
      {
        id: 119,
        label: 'menuitems.smartsheet.residential',
        link: '/smartsheet/residential',
        nombreModulo: 'nested_webpage_residencial'
      },
      {
        id: 119,
        label: 'menuitems.smartsheet.industrial_commercial',
        link: '/smartsheet/commercial-industrial',
        nombreModulo: 'nested_webpage_company'
      },
      {
        id: 119,
        label: 'menuitems.smartsheet.pmgd',
        link: '/smartsheet/pmgd',
        nombreModulo: 'nested_webpage_pmgd'
      },
    ]
  },
  {
    id: 120,
    label: 'menuitems.tracking.list',
    icon: 'mdi-account',
    link: '/time-sheet',
    nombreModulo: 'traking_hh'
  },
  {
    id: 121,
    label: 'menuitems.tutorial.text',
    icon: 'bx bx-help-circle',
    link: '/tutoriales',
    nombreModulo: 'tutorial'
  }
]
